import React, {useState} from "react";
import { Control, Delete, Field, Input } from "@allxsmith/bestax-bulma";
import {formatDate, readableDate} from "../../utils";



function Comment({
                   comment,
                   index,
                   updateComments,
                   removeComment,
                   disabled
                 }) {

  const handleChange = e => {
    const newComment = getNewComment(e);
    updateComments(newComment, index);
  };

  const getNewComment = e => {
    let newComment = {...comment, [e.target.name]: e.target.value};

    return newComment;
  };

  return (
    <tr>
      <td className={"comments-wrapper"}>
        <Field className="has-addons">
          <Control className="comments-wrapper">
            <Input
                type="text"
                value={comment.text}
                name="text"
                onChange={handleChange}
                data-testid="part-name"
                className={"comments-box"}
                disabled={disabled}
            />
          </Control>
        </Field>
      </td>
      <td>{readableDate(formatDate(new Date(comment.created)))}</td>
      <td>{comment ? comment.creator ? comment.creator_name : "" : ""}</td>
      <td className="comments-remove-button">
        <Delete
          type="button"
          onClick={() => removeComment(index)}
          data-testid="remove-part"
          disabled={disabled}>
          Remove
        </Delete>
      </td>
    </tr>
  );
}

export default Comment;
